module.exports = __webpack_public_path__ + "static/IOT-Based-Patient-Monitoring-6831ef01d71c8151e37a8a44b35e6dfa.jpg";